import parseDate from "date-fns/parse";

export const parse = (dateString, format, referenceDate) => {
  const date = parseDate(dateString, format, referenceDate ?? new Date());
  if (isNaN(date.getTime())) throw new Error("Invalid date");
  return date;
};
